export function parseCompSelector(startRenderer, startCompPath, selector) {
  var _renderer$ucFactoryLU;
  let renderer = startRenderer;
  let compPath = startCompPath;
  const sParts = selector.split(/\s+/);
  while (sParts.length && renderer && typeof compPath === 'string') {
    const part = sParts.shift();
    if (!part) continue;
    switch (part[0]) {
      case '/':
        compPath = part === '/' ? '' : part; // 特殊兼容： / 就是根节点
        break;
      case '^':
        {
          const requiredType = part.slice(1);
          if (requiredType === '^') {
            var _renderer$ucVNodeFact;
            // 特殊语法： ^^ 就是当前作用域插槽的 owner 组件（等同于 / ^ 的简写）
            compPath = ((_renderer$ucVNodeFact = renderer.ucVNodeFactory) === null || _renderer$ucVNodeFact === void 0 || (_renderer$ucVNodeFact = _renderer$ucVNodeFact.parent) === null || _renderer$ucVNodeFact === void 0 ? void 0 : _renderer$ucVNodeFact.compPath) || '';
            renderer = renderer.ucParentRenderer || renderer;
            break;
          }
          let it = renderer.ucFactoryLUT.byCompPath[compPath];
          let found = false;
          while (it && renderer) {
            const {
              parent
            } = it;
            if (!parent) break; // 不存在了，找不到了
            if (it.isScopeRoot) renderer = renderer.ucParentRenderer;
            it = parent;
            if (!requiredType || parent.comp.type === requiredType) {
              found = true;
              compPath = it.compPath;
              break;
            }
          }
          if (!found) compPath = null;
          break;
        }
      case '#':
        compPath = (_renderer$ucFactoryLU = renderer.ucFactoryLUT.byId[part.substr(1)]) === null || _renderer$ucFactoryLU === void 0 ? void 0 : _renderer$ucFactoryLU.compPath;
        break;
      default:
        throw new Error(`Invalid CompSelector part: ${part}`);
    }
  }
  if (!renderer || typeof compPath !== 'string') return null;
  return {
    renderer,
    compPath
  };
}
//# sourceMappingURL=compSelector.js.map
